module.exports = __webpack_public_path__ + "static/photo-mona-989e2560f8a66725e347e8425f40cd4a.jpg";